@if (partGroups !== undefined && columns !== null) {
    @if (collapsableGroupHeaders) {
        <ecs-group-toggle [customTabs]="customTabs"> </ecs-group-toggle>
    } @else {
        @if (partGroups.length > 0 && partGroups[0].rowData.title) {
            <ecs-group-toggle [groups]="partGroups" (groupSelect)="onGroupSelect($event)"> </ecs-group-toggle>
        }
    }
    <sew-search-field slot="search" class="part-table-search">
        <input
            id="search"
            type="text"
            placeholder="{{ 'SEARCH.ACTION.SEARCH' | translate }}"
            [ngModel]="tableSearchTerm"
            (ngModelChange)="onTableSearchTermChange($event)"
        />
    </sew-search-field>
    <osc-base-table
        #table
        [getUniqueGroupIdFunction]="getUniqueGroupIdFunction"
        [items]="partGroups"
        [columns]="columns"
        [groupHeaderColumns]="groupHeaderColumns"
        [trackBy]="trackById"
        [checkRowsNeeded]="checkRowsNeeded"
        [showExpandToggle]="true"
        [showScrollbarAtTop]="true"
        (rowSelect)="onRowSelect($event)"
        (rowMarked)="!isMobile && onRowMarked($event)"
        (requestRows)="onRequestRows()"
    >
        <ng-container cdkColumnDef="index">
            <th cdk-header-cell *cdkHeaderCellDef class="input-header header-index-number">
                <osc-text-filter-table-header
                    [name]="'SPARE_PARTS.TABLE.INDEX_NO' | translate"
                    [filterProperty]="'itemNumber'"
                    [tagPosition]="0"
                    sortOrder="ascending"
                    [ellipsis]="false"
                    [hideSortIconOnClosedState]="true"
                    class="header-index-number"
                    [showFilterInput]="false"
                ></osc-text-filter-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row">{{ row.rowData.itemNumber }}</td>
        </ng-container>
        <ng-container cdkColumnDef="itemNumber">
            <th cdk-header-cell *cdkHeaderCellDef class="input-header header-item-number">
                <osc-text-filter-table-header
                    [name]="'SPARE_PARTS.TABLE.ITEM_NO' | translate"
                    [filterProperty]="'itemNumber'"
                    [tagPosition]="0"
                    sortOrder="ascending"
                    [ellipsis]="false"
                    [hideSortIconOnClosedState]="true"
                    class="header-item-number"
                    [showFilterInput]="false"
                ></osc-text-filter-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row">{{ row.rowData.itemNumber }}</td>
        </ng-container>
        <ng-container cdkColumnDef="name">
            <th cdk-header-cell *cdkHeaderCellDef class="input-header">
                <osc-text-filter-table-header
                    [name]="'SPARE_PARTS.TABLE.PART_NAME' | translate"
                    [filterProperty]="'name'"
                    [tagPosition]="1"
                    [ellipsis]="false"
                    [hideSortIconOnClosedState]="true"
                    class="header-part-name"
                    [showFilterInput]="false"
                ></osc-text-filter-table-header>
            </th>
            <td
                cdk-cell
                *cdkCellDef="let row"
                [innerHTML]="row.rowData.name | convertLinebreakToHtml"
                class="name-text"
            ></td>
            [innerHTML]="comment"
        </ng-container>
        <ng-container cdkColumnDef="materialNumber">
            <th cdk-header-cell *cdkHeaderCellDef class="input-header">
                <osc-text-filter-table-header
                    [name]="'SPARE_PARTS.TABLE.MAT_NO' | translate"
                    [filterProperty]="'id'"
                    [tagPosition]="2"
                    [ellipsis]="false"
                    [hideSortIconOnClosedState]="true"
                    class="header-material-number"
                    [showFilterInput]="false"
                ></osc-text-filter-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row">{{ row.rowData.id }}</td>
        </ng-container>
        <ng-container cdkColumnDef="wear">
            <th cdk-header-cell *cdkHeaderCellDef>
                <osc-text-filter-table-header
                    [name]="'SPARE_PARTS.TABLE.WEAR' | translate"
                    [filterProperty]="'wear'"
                    [tagPosition]="2"
                    [ellipsis]="false"
                    [hideSortIconOnClosedState]="true"
                    class="header-wear"
                    [showFilterInput]="false"
                ></osc-text-filter-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row">
                @if (row.rowData.wear) {
                    <sew-icon icon="gear-drop" class="wear-icon" [oscTooltip]="wearTooltip"></sew-icon>
                }
            </td>
        </ng-container>
        <ng-container cdkColumnDef="amount">
            <th cdk-header-cell *cdkHeaderCellDef>
                <osc-text-table-header
                    [name]="'SPARE_PARTS.TABLE.AMOUNT' | translate"
                    [ellipsis]="false"
                    class="header-amount"
                ></osc-text-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row" class="amount-row">
                <ng-template #tooltipResetToInstalledQuantity>
                    <osc-default-tooltip>
                        {{ 'TOOLTIP.RESET_TO_INSTALLED_QUANTITY' | translate }}
                    </osc-default-tooltip>
                </ng-template>
                @if (partAmounts[row.uniqueId] !== (row.rowData.installedQuantity ?? 1)) {
                    <sew-button
                        class="amount-button"
                        icon="restore"
                        hierarchy="tertiary"
                        size="xs"
                        [oscTooltip]="tooltipResetToInstalledQuantity"
                        show-icon-only
                    >
                        <button
                            (click)="partAmounts[row.uniqueId] = row.rowData.installedQuantity ?? 1"
                        ></button>
                    </sew-button>
                }
                <sew-table-input>
                    <input
                        type="number"
                        min="1"
                        class="amount-input"
                        [(ngModel)]="partAmounts[row.uniqueId]"
                        [disabled]="row.isDisabled"
                        oscNumbersOnly
                    />
                </sew-table-input>
            </td>
        </ng-container>
        <ng-container cdkColumnDef="availability">
            <th cdk-header-cell *cdkHeaderCellDef>
                <osc-text-table-header
                    [name]="'SPARE_PARTS.TABLE.AVAILABILITY' | translate"
                    [ellipsis]="false"
                    class="header-availability"
                ></osc-text-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row">
                @if (userStatus?.isUserLoggedIn) {
                    <ng-container *oscNgUse="row.rowData.availabilityCode as availabilityCode">
                        @if (availabilityCode === '00' || availabilityCode === '04') {
                            @if (row.rowData.availability === undefined) {
                                <sew-loader-mini></sew-loader-mini>
                            } @else {
                                <ecs-availability-cell
                                    [availability]="row.rowData.availability"
                                ></ecs-availability-cell>
                            }
                        } @else {
                            <!-- #784985 Prevent text for item substitution items to bleed out of the tabel -->
                            <span class="word-break">{{ row.rowData.availabilityText }}</span>
                        }
                    </ng-container>
                } @else {
                    @if (row.rowData.availabilityCode !== '05') {
                        <sew-link icon="lock-locked">
                            <a [href]="loginUrl">{{ 'LOGIN' | translate }}</a>
                        </sew-link>
                    } @else {
                        {{ row.rowData.availabilityText }}
                    }
                }
            </td>
        </ng-container>
        <ng-container cdkColumnDef="addToBasket">
            <th cdk-header-cell *cdkHeaderCellDef></th>
            <td cdk-cell *cdkCellDef="let row">
                @let hasRecommendation = showPartsRecommendation(row);
                <div
                    class="add-to-basket-actions"
                    [class.no-secondary-action]="
                        !(hasRecommendation && contentReductionLevel < ReductionLevel.THIRD)
                    "
                >
                    <div class="add-to-basket-action-secondary">
                        @if (hasRecommendation && contentReductionLevel < ReductionLevel.THIRD) {
                            <ng-container
                                *ngTemplateOutlet="partsRecommendation; context: { row: row }"
                            ></ng-container>
                        }
                    </div>
                    <div class="add-to-basket-action-primary">
                        <ng-container
                            *ngTemplateOutlet="
                                row.rowData.availabilityCode === '05' || row.rowData.availabilityCode === '09'
                                    ? driveConfiButton
                                    : basketButton;
                                context: { row: row }
                            "
                        >
                        </ng-container>
                    </div>
                </div>
            </td>
        </ng-container>

        <ng-container cdkColumnDef="expandableRow">
            <td cdk-cell *cdkCellDef="let row" colspan="100%" class="expandable-row">
                @let hasRecommendation = showPartsRecommendation(row);
                <dl>
                    <dt>{{ 'SPARE_PARTS.TABLE.PART_NAME' | translate }}:</dt>
                    <dd [innerHTML]="row.expandData.name | convertLinebreakToHtml"></dd>
                </dl>
                @if (contentReductionLevel >= ReductionLevel.SECOND) {
                    <dl>
                        <dt>{{ 'SPARE_PARTS.TABLE.MAT_NO' | translate }}:</dt>
                        <dd>{{ row.expandData.id }}</dd>
                    </dl>
                }
                @if (row.expandData.wear && contentReductionLevel >= ReductionLevel.SECOND) {
                    <dl class="expandable-row-wear">
                        <dt>{{ 'SPARE_PARTS.TABLE.WEAR' | translate }}:</dt>
                        <dd><sew-icon icon="gear-drop" class="wear-icon"></sew-icon></dd>
                    </dl>
                }
                @if (userStatus?.isUserLoggedIn && contentReductionLevel >= ReductionLevel.THIRD) {
                    <dl>
                        <dt>{{ 'SPARE_PARTS.TABLE.AVAILABILITY' | translate }}:</dt>
                        @if (
                            row.expandData.availabilityCode === '00' ||
                            row.expandData.availabilityCode === '04'
                        ) {
                            <dd>{{ row.expandData.availability?.tooltip }}</dd>
                        } @else {
                            <dd>{{ row.expandData.availabilityText }}</dd>
                        }
                    </dl>
                }
                @if (hasRecommendation && contentReductionLevel >= ReductionLevel.THIRD) {
                    <ng-container
                        *ngTemplateOutlet="partsRecommendationExpanded; context: { row: row }"
                    ></ng-container>
                }
                <!-- @if (isMobile) {
                    <ng-container *ngTemplateOutlet="drawingExpanded; context: { row: row }"></ng-container>
                } -->
            </td>
        </ng-container>
        <ng-container cdkColumnDef="fullRowContent"></ng-container>

        <ng-container cdkColumnDef="groupHeaderIcon">
            <td *cdkCellDef="let group">
                @if (group.rowData.iconName) {
                    <sew-icon class="drive-group-icon" icon="{{ group.rowData.iconName }}"></sew-icon>
                }
            </td>
        </ng-container>

        <ng-container cdkColumnDef="groupHeaderName">
            <td
                *cdkCellDef="let group"
                [attr.colspan]="
                    collapsableGroupHeaders
                        ? '100%'
                        : contentReductionLevel === ReductionLevel.NONE ||
                            contentReductionLevel > ReductionLevel.SECOND
                          ? columns.length - 2
                          : columns.length - 3
                "
                class="group-header-title"
            >
                {{ group.rowData.driveGroupProductName }} {{ group.rowData.title }}
            </td>
        </ng-container>

        <ng-container cdkColumnDef="groupHeaderAddToBasket">
            <td
                cdk-cell
                *cdkCellDef="let group"
                [attr.colspan]="
                    contentReductionLevel === ReductionLevel.NONE ||
                    contentReductionLevel > ReductionLevel.SECOND
                        ? 1
                        : 2
                "
            >
                <div
                    class="drivegroup-basket"
                    [class.disable-pointer-events]="hideAddDriveGroupToBasket(group.rowData.driveGroup)"
                >
                    <ng-template #tooltipAddToCartGroup>
                        <osc-default-tooltip>
                            {{ 'TOOLTIP.ADD_TO_CART.GROUP' | translate: { groupTitle: group.rowData.title } }}
                        </osc-default-tooltip>
                    </ng-template>
                    <ng-template #tooltipAddAtexToCartGroupDisabled>
                        <osc-default-tooltip>
                            {{ 'TOOLTIP.ADD_ATEX_GEAR_TO_CART.GROUP' | translate }}
                        </osc-default-tooltip>
                    </ng-template>
                    <ng-template #tooltipAddToCartGroupDisabled>
                        <osc-default-tooltip>
                            {{ group.rowData.disableAddGroupToCartText }}
                        </osc-default-tooltip>
                    </ng-template>
                    <sew-button
                        #button
                        icon="shopping-cart"
                        [showIconOnly]="contentReductionLevel > ReductionLevel.SECOND"
                        hierarchy="secondary"
                        size="xs"
                    >
                        <button
                            (click)="$event.stopPropagation(); addGroupToCart(group)"
                            oscTrackClick="parts.addToCartGroup"
                            translate
                            [disabled]="
                                hideAddDriveGroupToBasket(group.rowData.driveGroup) ||
                                group.rowData.disableAddGroupToCart === true
                            "
                        >
                            <!-- Workaround https://stackoverflow.com/a/63453782 for problem https://github.com/reach/reach-ui/issues/231#issuecomment-541182111-->
                            <!-- Tooltip won't be shown on a disabled element -->
                            <span
                                [oscTooltip]="
                                    hideAddDriveGroupToBasket(group.rowData.driveGroup)
                                        ? tooltipAddAtexToCartGroupDisabled
                                        : group.rowData.disableAddGroupToCart === true
                                          ? tooltipAddToCartGroupDisabled
                                          : tooltipAddToCartGroup
                                "
                                [tooltipPositions]="['top']"
                                translate
                                >ACTION.ADD_TO_CART.GROUP</span
                            >
                        </button>
                    </sew-button>
                </div>
            </td>
        </ng-container>

        <ng-template #actionBar let-checkedRows>
            <div class="action-bar">
                <div>
                    <sew-button
                        icon="download"
                        size="xs"
                        hierarchy="secondary"
                        [showIconOnly]="contentReductionLevel === ReductionLevel.THIRD"
                    >
                        <button
                            style="pointer-events: all"
                            (click)="
                                !userStatus?.isUserEmployee
                                    ? downloadSelectedItemsAsCsvFile()
                                    : (isExportCSVDialogVisible = true)
                            "
                            [disabled]="!checkedRows.length"
                        >
                            <!-- Workaround https://stackoverflow.com/a/63453782 for problem https://github.com/reach/reach-ui/issues/231#issuecomment-541182111-->
                            <!-- Tooltip won't be shown on a disabled element -->
                            <span
                                [oscTooltip]="tooltipExportSelectedRowsAsCsvFile"
                                [tooltipPositions]="['right']"
                                translate
                                >{{ 'ACTION.EXPORT_EXCEL.TEXT' | translate }}</span
                            >
                        </button>
                    </sew-button>
                    <!-- @if (userStatus?.isUserLoggedIn) {
                        <sew-button
                            #wishlistButton
                            icon="star"
                            size="xs"
                            [showIconOnly]="contentReductionLevel === ReductionLevel.THIRD"
                        >
                            <button (click)="addToWishList(checkedRows)" [disabled]="!checkedRows.length">
                                {{ 'PRODUCT.WISHLIST_ADD' | translate }}
                            </button>
                        </sew-button>
                    } -->
                </div>
                <sew-button #button icon="shopping-cart" size="xs">
                    <button
                        (click)="addSelectionToCart(checkedRows)"
                        oscTrackClick="parts.addToCartActionbar"
                        [disabled]="!checkedRows.length"
                    >
                        {{ 'ACTION.ADD_TO_CART.MULTIPLE' | translate }}
                    </button>
                </sew-button>
            </div>
        </ng-template>
    </osc-base-table>
    <sew-dialog
        [open]="isExportCSVDialogVisible"
        close-button="true"
        (close)="isExportCSVDialogVisible = false; exportCSVType = CSVExportType.EXTERNAL"
        [headline]="'ACTION.EXPORT_EXCEL.DIALOG.HEADLINE' | translate"
    >
        <p>{{ 'ACTION.EXPORT_EXCEL.DIALOG.TEXT' | translate }}</p>
        <div class="sew-theme-padding">
            <sew-radio-group>
                <sew-radio>
                    <input
                        name="csv-internal-radio"
                        type="radio"
                        id="csv-internal-radio"
                        [checked]="exportCSVType === CSVExportType.INTERNAL"
                        (change)="exportCSVType = CSVExportType.INTERNAL"
                    />
                    <label for="csv-internal-radio">{{
                        'ACTION.EXPORT_EXCEL.DIALOG.RADIO.LABEL.INTERNAL' | translate
                    }}</label>
                </sew-radio>
                <sew-radio>
                    <input
                        name="csv-external-radio"
                        type="radio"
                        id="csv-external-radio"
                        [checked]="exportCSVType === CSVExportType.EXTERNAL"
                        (change)="exportCSVType = CSVExportType.EXTERNAL"
                    />
                    <label for="csv-external-radio">{{
                        'ACTION.EXPORT_EXCEL.DIALOG.RADIO.LABEL.EXTERNAL' | translate
                    }}</label>
                </sew-radio>
            </sew-radio-group>
        </div>
        <sew-ws-button slot="button"
            ><button (click)="isExportCSVDialogVisible = false; exportCSVType = CSVExportType.EXTERNAL">
                {{ 'ACTION.EXPORT_EXCEL.DIALOG.BUTTON.CANCEL' | translate }}
            </button></sew-ws-button
        >
        <sew-ws-button slot="button"
            ><button
                (click)="
                    downloadSelectedItemsAsCsvFile();
                    isExportCSVDialogVisible = false;
                    exportCSVType = CSVExportType.EXTERNAL
                "
            >
                {{ 'ACTION.EXPORT_EXCEL.DIALOG.BUTTON.EXPORT' | translate }}
            </button></sew-ws-button
        >
    </sew-dialog>
} @else {
    <ecs-part-table-skeleton
        [showGroupHeader]="showPartGroupHeaderAsSkeleton"
        [rowCount]="9"
    ></ecs-part-table-skeleton>
}

<ng-template #tooltipExportSelectedRowsAsCsvFile>
    <osc-default-tooltip>
        {{ 'ACTION.EXPORT_EXCEL.TOOLTIP' | translate }}
    </osc-default-tooltip>
</ng-template>

<ng-template #basketButton let-row="row">
    <sew-button
        #button
        icon="shopping-cart"
        hierarchy="secondary"
        size="xs"
        [showIconOnly]="contentReductionLevel > ReductionLevel.NONE"
    >
        <button
            [disabled]="row.isDisabled"
            oscTrackClick="parts.addToCartSingle"
            (click)="$event.stopPropagation(); addSelectionToCart([row])"
        >
            {{ 'ACTION.ADD_TO_CART.SINGLE' | translate }}
        </button>
    </sew-button>
</ng-template>

<ng-template #driveConfiButton let-row="row">
    <sew-button
        icon="external-link"
        hierarchy="secondary"
        size="xs"
        [showIconOnly]="contentReductionLevel > ReductionLevel.NONE"
    >
        <button
            oscTrackClick="parts.redirectToDriveConfi"
            (click)="$event.stopPropagation(); openDriveConfigurator(row.rowData)"
        >
            {{ 'ACTION.OPEN' | translate }}
        </button>
    </sew-button>
</ng-template>

<ng-template #wearTooltip>
    <osc-default-tooltip>
        {{ 'SPARE_PARTS.TABLE.TOOLTIP.WEAR' | translate }}
    </osc-default-tooltip>
</ng-template>

<ng-template #partsRecommendation let-row="row">
    <sew-button hierarchy="secondary" size="xs" [showIconOnly]="contentReductionLevel > ReductionLevel.NONE">
        <button
            class="parts-recommendation-btn"
            [class.active]="
                isRecommendationAccordionAvailable &&
                isDesktopRecommendationAccordionExpanded &&
                selectedRowId === row.rowData.id
            "
            (click)="$event.stopPropagation(); onRowMarked(row)"
        >
            <mat-icon
                [svgIcon]="
                    isRecommendationAccordionAvailable &&
                    isDesktopRecommendationAccordionExpanded &&
                    selectedRowId === row.rowData.id
                        ? 'light-bulb-white'
                        : 'light-bulb'
                "
            >
            </mat-icon>
        </button>
    </sew-button>
</ng-template>

<ng-template #partsRecommendationExpanded let-row="row">
    <div class="parts-recommendation-expanded-wrapper">
        <sew-button hierarchy="secondary" size="xs">
            <button
                class="parts-recommendation-btn-expanded"
                (click)="$event.stopPropagation(); onRowMarked(row)"
            >
                <mat-icon svgIcon="light-bulb"></mat-icon>
                {{ 'PRODUCT.PARTS_RECOMMENDATION.TITLE' | translate }}
            </button>
        </sew-button>
    </div>
</ng-template>

<ng-template #drawingExpanded let-row="row">
    <div class="parts-recommendation-expanded-wrapper">
        <sew-button hierarchy="secondary" size="xs">
            <button
                class="parts-recommendation-btn-expanded"
                (click)="$event.stopPropagation(); onShowInDrawing()"
            >
                {{ 'SHOW_IN_DRAWING' | translate }}
            </button>
        </sew-button>
    </div>
</ng-template>
